<template>
  <div>
    <my-account-become-premium v-if="! isPremium" :coupon="coupon" @set-coupon="$emit('set-coupon', $event)"></my-account-become-premium>
    <div v-else class="page">
      <div class="row">
        <!-- FACTURATION -->
        <div class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-subscription :user="user" :subscription-promise="subscriptionPromise" :available-plans="availablePlans"></my-account-premium-subscription>
        </div>
        <!-- ADDING USERS -->
        <div v-if="hasStripePlan && hasStripeSubscription" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-users :user="user"></my-account-premium-users>
        </div>

        <!-- BLOCK ECONOMIZE -->
        <div v-if="(billingPlan == 'TEAM' || billingPlan == 'BUSINESS') && hasStripeSubscription" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-yearly :user="user" :available-plans="availablePlans"></my-account-premium-yearly>
        </div>
        <div class="py-8"></div>
        <!-- BLOCK UPGRADE -->
        <div v-if="(billingPlan == 'TEAM' || billingPlan == 'TEAM12M') && hasStripeSubscription" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-business :user="user" :available-plans="availablePlans"></my-account-premium-business>
        </div>

        <!-- BLOCK BUBBLE MEETING -->
        <div v-if="hasStripePlan && hasStripeSubscription" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-meeting :user="user" :available-plans="availablePlans"></my-account-premium-meeting>
        </div>
        <!-- BLOCK CONSULT -->
        <div v-if="hasStripePlan && hasStripeSubscription" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-consult :user="user" :available-plans="availablePlans"></my-account-premium-consult>
        </div>

        <!-- BLOCK CUSTOM FORM -->
        <!-- <div v-if="! hasStripePlan" class="col-lg-6 col-md-12 mb-5">
          <my-account-premium-custom :user="user" :available-plans="availablePlans"></my-account-premium-custom>
        </div> -->
      </div>
      <!-- BLOCK CONTACT -->
      <div class="row">
        <div class="col-12">
          <div class="card shadow-4">
            <div class="card-body">
              <div class="px-5">
                <h5 class="text-primary mb-3">Contact</h5>
                Pour toute autre demande concernant votre compte Premium,
                contactez-nous à <a href="mailto:premium@bubbleplan.net" target="_blank">premium@bubbleplan.net</a>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .card-description {
    font-weight: 400;
  }
</style>

<script>
  import apiSrv from '../apiSrv';
  // import testProfile from '../tests/testProfile';
  import MyAccountBecomePremium from './BecomePremium.vue';
  import MyAccountPremiumSubscription from './PremiumSubscription.vue';
  import MyAccountPremiumUsers from './PremiumUsers.vue';
  import MyAccountPremiumYearly from './PremiumYearly.vue';
  import MyAccountPremiumBusiness from './PremiumBusiness.vue';
  import MyAccountPremiumMeeting from './PremiumMeeting.vue';
  import MyAccountPremiumConsult from './PremiumConsult.vue';
  // import MyAccountPremiumCustom from './PremiumCustom.vue';

  export default {
    components: {
      MyAccountBecomePremium,
      MyAccountPremiumSubscription,
      MyAccountPremiumUsers,
      MyAccountPremiumYearly,
      MyAccountPremiumBusiness,
      MyAccountPremiumMeeting,
      MyAccountPremiumConsult,
      // MyAccountPremiumCustom,
    },
    props: {
      coupon: { type: String, required: true },
    },
    data() {
      return {
        user: null,
        subscriptionPromise: null,
        hasStripeSubscription: null,
        availablePlans: {
          BUSINESS: { name: 'BUSINESS MENSUEL', period: 'mensuel', price: 29.9, consults: 20 },
          BUSINESS12M: { name: 'BUSINESS ANNUEL', period: 'annuel', price: 298.8, consults: 20 },
          TEAM: { name: 'TEAM MENSUEL', period: 'mensuel', price: 15.5, consults: 10 },
          TEAM12M: { name: 'TEAM ANNUEL', period: 'annuel', price: 154.8, consults: 10 },
          PERSONALLIGHT: { name: 'PERSONAL LIGHT', period: 'mensuel', price: 8, consults: 2 },
          BUSINESS2021: { name: 'BUSINESS MENSUEL', period: 'mensuel', price: 26.4, consults: 20 },
          BUSINESS12M2021: { name: 'BUSINESS ANNUEL', period: 'annuel', price: 264, consults: 20 },
          TEAM2021: { name: 'TEAM MENSUEL', period: 'mensuel', price: 14.4, consults: 10 },
          TEAM12M2021: { name: 'TEAM ANNUEL', period: 'annuel', price: 144, consults: 10 },
        },
      };
    },
    computed: {
      company() {
        return this.user && this.user.company;
      },
      isPremium() {
        return this.company && this.company.isPremium;
      },
      premiumMaxUsers() { return this.company && this.company.maxusers; },
      premiumMaxConsults() { return this.company && this.company.maxconsults; },
      hasStripeAccount() { return this.company && this.company.hasStripeAccount; },
      billingPlan() { return this.company && this.company.billing_plan; },
      hasStripePlan() {
        return ['TEAM', 'TEAM12M', 'BUSINESS', 'BUSINESS12M', 'TEAM2021', 'TEAM12M2021', 'BUSINESS2021', 'BUSINESS12M2021'].includes(this.billingPlan);
      },
    },
    created() {
      apiSrv.loadUser().then((user) => {
        // uncomment the line bellow to use testProfile scenarios
        // user = { ...user, ...testProfile, company: { ...user.company, ...testProfile.company } };
        this.user = user;
      });
      this.subscriptionPromise = apiSrv.call(`${window.api.buy.url}/plan`, 'GET').then((response) => {
        // uncomment the line bellow to use testProfile scenarios
        // response = { ...response, ...testProfile.stripePlan };
        this.hasStripeSubscription = !! (response.subscription && response.subscription.length);
        return response;
      });
    },
  };
</script>
